<template>
    <div class="contenedor-main-grafica-avances-estimaciones">
        <grafica-avances
            :estimacion="estimacion"
            :contratoEstimaciones="contratoEstimaciones"
            :contrato="contrato"
            :programasobra="programasobra"
            :firmas="firmas"
            @mostrarGrafica="mostrarGrafica">
        </grafica-avances>
    </div>
</template>
<script>
import GraficaAvances from '@/components/administracion/ejecucion/estimaciones/reportes/GraficaAvanceEstimaciones.vue';
/* import mixGenerarPdf from '@/helpers/mixGenerarPdf';
 import mixFormatoEstructura from '@/helpers/mixFormatoEstructura';
 import mixGraficaAvanceEstimaciones from '@/components/administracion/ejecucion
 /estimaciones/reportes/mixGraficaAvanceEstimaciones';
 */
import mixDescargaGraficaAvanceEstimaciones from './mixDescargaGraficaAvanceEstimaciones';

export default {
  name: 'MainGraficaAvancesEstimaciones',
  props: {
    estimacion: {
      type: Object,
      required: true,
    },
    contratoEstimaciones: {
      type: Array,
      required: true,
    },
    contrato: {
      type: Object,
      required: true,
    },
    programasobra: {
      type: Array,
      required: true,
    },
    firmas: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {
      activarMostrarGrafica: false,
    };
  },
  components: {
    GraficaAvances,
  },
  mixins: [
    // mixGenerarPdf,
    // mixFormatoEstructura,
    // mixGraficaAvanceEstimaciones,
    mixDescargaGraficaAvanceEstimaciones,
  ],
/*
  methods: {
    mostrarGrafica() {
      this.activarMostrarGrafica = true;
      this.$emit('mostrarGrafica');
    },
    formatoObjeto(objeto) {
      return this.formatoEstructura(objeto);
    },
    async generarPdfGraficaAvance() {
      this.$emit('generando');
      const grafica = this.mixCalcularPuntosGrafica;
      const graficaConFormato = {
        programado: grafica.programado
          .map((p) => `$${p.toLocaleString('es-MX',
            { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`),
        financiero: grafica.financiero
          .map((p) => `$${p.toLocaleString('es-MX',
            { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`),
        programadoP: grafica.programadoPorcentaje.map((p) => `${p}%`),
        financieroP: grafica.financieroPorcentaje.map((p) => `${p}%`),
        numeroMeses: grafica.programado.length,
      };
      const contratoConFormato = this.formatoObjeto(this.contrato);
      const estimacionConFormato = this.formatoObjeto(this.estimacion);
      const datos = {
        supervisionExterna: this.getContratoSupervisionExterna?.contratoRelacionado
          ?.contratista?.nombreRazonSocial || '',
      };
      const supervisor = this.getSupervisor || '';
      const firmasFuncionarios = this.firmas;
      let nombreTemplate = 'templateGraficaAvanceEstimacion';
      if (this.contrato.esObraFinanciada) { nombreTemplate = 'templateGraficaAvanceEstimacion'; }

      await this.mixGenerarPdf({
        configuracion: {
          path: 'wepp/wep',
          PUPPETEER_CONFIGURACION: {
            landscape: true,
            format: 'A3',
          },
          nombreTemplate,
        },
        data: {
          grafica,
          graficaConFormato,
          contrato: contratoConFormato,
          estimacion: estimacionConFormato,
          supervisor,
          firmas: firmasFuncionarios,
          datos,
          footer: '',
        },
      }, `${this.contrato.numero}_GraficaAvanceEstimacion_${this.estimacion.numero}`);
      this.generandoPdfGraficaAvanceEstimaciones = false;
      this.$emit('terminando');
    },

  },
  computed: {
    getSupervisor() {
      if (!this.contrato) return null;
      if (!this.contrato.responsables) return null;
      return this.contrato.responsables.find((responsable) => responsable.principal === true);
    },
    getContratoSupervisionExterna() {
      if (this.contrato.contratosRelacionados.length <= 0) return null;
      return this.contrato.contratosRelacionados
        .find(({ esSupervisionExterna }) => esSupervisionExterna === true);
    },
  },
*/
};
</script>
